import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface CollapseDrawerIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const CollapseDrawerIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: CollapseDrawerIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 3.7H9.30001H5.00001C3.72976 3.7 2.70001 4.72974 2.70001 6V18C2.70001 19.2703 3.72976 20.3 5.00001 20.3H9.30001H19C20.2703 20.3 21.3 19.2703 21.3 18V6C21.3 4.72974 20.2703 3.7 19 3.7ZM9.30001 19H19C19.5523 19 20 18.5523 20 18V6C20 5.44771 19.5523 5 19 5H9.30001V19ZM8.00001 5H5.00001C4.44773 5 4.00001 5.44771 4.00001 6V18C4.00001 18.5523 4.44773 19 5.00001 19H8.00001V5Z"
                fill={color}
            />
        </svg>
    )
}

export default CollapseDrawerIcon
